"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

import { eventOfLink, trackEvent, trackPageView } from "@/lib/analytics/beacon";

// =============================================================================

/**
 * One cookieless page view per page shown (client navigations included).
 * The external referrer only counts for the first page of the visit. Clicks
 * on links carrying trackAttributes send their event.
 */
export function PageViewTracker() {
  const pathname = usePathname();
  const isFirstView = useRef(true);

  useEffect(() => {
    const { pathname: path, search } = window.location;
    trackPageView(
      `${path}${search}`,
      isFirstView.current ? document.referrer : null
    );
    isFirstView.current = false;
  }, [pathname]);

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const link = (event.target as Element | null)?.closest<HTMLElement>(
        "[data-track]"
      );
      const tracked = link && eventOfLink(link);
      if (tracked) trackEvent(tracked.name, tracked.meta);
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}

// =============================================================================
